<template>
  <div class="down">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="联盟资料下载" name="first">
        <div class="material" v-loading="loading">
          <template v-if="!material.length">暂无数据</template>
          <template v-else>
            <div
              v-for="(item, index) in material"
              :key="index"
              class="down-item"
            >
              <a :href="item.resourceUrl" target="blank">{{
                item.resourceName
              }}</a>
            </div>
          </template>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { allianceMaterial } from "@/api/allianceZone";
export default {
  data() {
    return {
      activeName: "first",
      material: [],
      page: {
        pageIndex: 1,
        pageSize: 100,
      },
      loading: false,
    };
  },
  created() {
    this.getMaterial();
  },
  methods: {
    async getMaterial() {
      this.loading = true;
      const { list } = await this.$axios
        .get(allianceMaterial, { leagueId: this.$route.query.id, ...this.page })
        .finally(() => {
          this.loading = false;
        });
      this.material = list || [];
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.down {
  margin-bottom: 20px;
  /deep/ .el-tabs__header .el-tabs__item {
    font-size: 18px !important;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: $theme-color;
    color: #fff;
    border: 1px solid $theme-color;
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 0px;
  }
  ::v-deep .el-tabs__content {
    background: #fff;
    border: none;
    padding: 16px;
  }
  &-item {
    margin-bottom: 15px;
  }
}
.material {
  min-height: 80px;
}
</style>
